import { useQuery } from "@tanstack/react-query";

import { chatApi, useApiClient } from "../../api";
import { ChatV1 } from "../../api/schema/openapi";
import { QUERY_KEYS } from "../../constants";

export const useChatHistory = () => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: [...QUERY_KEYS.chatHistory(), apiClient],
    queryFn: async (): Promise<ChatV1[]> => {
      const response = await chatApi.getChats(apiClient);
      return response.data || [];
    },
    enabled: !!apiClient,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 20 * 1000, // 20 seconds
  });
};
